
export default {
    'asset.title': '净资产',
    'asset.cash': '现金',
    'asset.market': '持仓市值',
    'asset.max.power': '最大购买力',
    'user.Financing.risk': '融资风险',
    'user.save': '安全',
    'user.jingjie': '警戒',
    'user.zhuijiao': '追缴',
    'user.Forced.ping': '强平',
    'asset.card.buy': '买入',
    'asset.card.sell': '卖出',
    'asset.recharge':'入金',
    'asset.withdraw':'出金',
    'asset.exchange':'换汇',
    'asset.cash.detail':'资金明细',
    'asset.capitalFlow':'资金流水',
    'asset.assetRecord':'出入金流水',
    'user.Position': '持仓',
    'asset.section2.title': '挂单',
    'asset.section3.title':'历史订单',
    'user.Position.price': '持仓价 | 数量',
    'user.Position.pv': '现价 | 市值',
    'asset.section1.table8': '盈亏',

    'asset.his.all': '全部',
    'asset.his.buy': '买入',
    'asset.his.sell': '卖出',
    'asset.his.exer': '行权',
    'asset.his.done': '全成',
    'asset.his.tab1': '交易单',
    'asset.his.tab2': '申购单',
    'asset.his.tab3': '股票',
    'asset.his.tab4': '美股期权',
    'asset.his.tab5': 'IPO',
    'asset.his.type': '类型',
    'asset.his.date': '日期',
    'asset.his.status': '状态',
    'asset.his.apply.price': '下单价',
    'asset.his.apply.ipo.price': '申购价',
    'asset.his.amount': '数量',
    'asset.his.ipo.deal': '中签价',
    'asset.his.trans.deal': '成交价',
    'asset.table.market.price':'市价',
    'asset.order.change':'改单',
    'asset.order.cancel': '撤单',
    'member.price': '价格',
    'asset.order.cancel.confirm': '确认撤单吗？',
    'asset.history.detai.t': '费用明细',
    'asset.history.detai.item1': '交易佣金',
    'asset.history.detai.item2': '印花税',
    'asset.history.detai.item3': '过户费',
    'asset.history.detai.item4': '证监会费',
    'asset.history.detai.item5': '交收费',
    'asset.history.detai.item6': '经手费',
    'asset.history.detai.item7': '证管费',
    'asset.history.detai.item8': '交收费/过户费',
    'asset.history.detai.item9': '交易费',
    'asset.history.detai.item10': '交易征费',
    'asset.history.detai.item11': '交易费活动费',
    'asset.history.detai.item12': '结算使用费',
    'asset.history.detai.item13': '结算使用费',
    'asset.history.detai.item14': '交易系统使用费',
    'asset.history.detai.item15': '暗盘交易费',
    'asset.table.more': '查看更多',
    'history.list.status.1': '全部',
    'history.list.status.2': '全成',
    'history.list.status.3': '已撤',
    'history.list.status.4': '部成部撤',
    'history.list.status.5': '废单',
    'history.list.status.Bid': '买入',
    'history.list.status.Offer': '卖出',
    'history.list.status.Exercise': '行权',
    'history.list.status.Inactive': '废单',
    'history.list.status.Cancelled': '已撤',
    'history.list.status.Filled': '已成',
    'asset.has.awarded':'已中签',
    'asset.not.awarded':'未中签',
    'asset.logout.title':'一个账户投资全球',
    'asset.logout.title.desc':'完成注册WBroker账户，开始您的第一笔投资。',
    'asset.page.desc':'提供优质的港股、美股、A股通投资通道',
    'asset.open.account':'立即开户',
    'asset.logout.has.account.1':'已有WBroker账户，请',
    'asset.logout.has.account.2':'点此登录',
    'asset.logout.has.account.3':'',
    //已有WBroker账户，请点此登录
    'asset.logout.desc.item1':'出金日内到账，7*24小时极速入金',
    'asset.logout.desc.item2':'0门槛10分钟线上开户',
    'asset.logout.desc.item3':'支持港股、美股及A股通交易',
    'asset.processing.step1':'注册',
    'asset.processing.step1.desc':'提交时间',
    'asset.processing.step2':'审核中',
    'asset.processing.step2.desc':'预计1个小时（工作日）',
    'asset.processing.step3':'开户成功',

    //入金
    'recharge.digital':'存入稳定币',
    'asset.recharge.USDT': '存入USDT',
    'recharge.USDC': '存入USDC',
    'asset.HKD': '港币',
    'asset.USD': '美元',
    'asset.CNY': '人民币',
    'asset.recharge.min.tip': '存入数量不能小于',
    'asset.recharge.min.tip1': '存入数量需大于手续费',
    'user.btn.sibmit': '提交',
    'recharge.currency': '存入币种',
    'asset.recharge.chainName':'链名称',
    'asset.recharge.feeRate': '手续费：',
    'asset.recharge.amount': '存入数量',
    'asset.recharge.amount.placeHolder': '请输入存入数量',
    'asset.recharge.amount.min': '最小存入数量需大于预计手续费',
    'asset.recharge.fee': '预计手续费：',
    'asset.recharge.toAmount': '存入后兑换成',
    'asset.rate': '汇率：',
    'asset.recharge.address': '充值地址：',
    'asset.recharge.click': '点击地址可',
    'asset.recharge.click.2': '复制',
    'asset.tips.title': '温馨提示：',
    'asset.recharge.tips1': '1、使用WBroker服务，即视为同意',
    'asset.recharge.tips2': '《用户条款》',
    'asset.recharge.tips3': '。如不同意，请勿使用。',
    'asset.recharge.tips4': '2、24小时入金，十分钟内到账，记得选择兑换的币种哦。',
    'asset.recharge.tips5': '3、WBroker不支持使用合约地址入金。如不慎使用，请联系客服处理入金并对入金账户收取不低于10USDT操作费。',
    'recharge.important.tip4': '4、转账时请确认链名称，若转错链，将损失入金金额的5%~10%且不低于200USDT的费用或无法找回。',
    'user.copy.success': '复制成功',
    'shareImg.long.press': '长按',
    'shareImg.long.press.1': '保存二维码',
    'asset.resultTipA':'预计将于您充值成功后的10分钟内入金到账，请耐心等候，到账后我们会第一时间通知您。',
    'lend.result.contact': '如需帮助请联系',
    'lend.result.contact.servers': '在线客服',
    'user.back': '返回',
    'user.contact.servers': '在线客服',

    //出金
    'asset.order.tip.max':'出金金额不能大于可用金额',
    'asset.order.tip.min':'出金金额需大于手续费',
    'user.getVerifyCodeFirst': '请先获取验证码',
    'withdraw.auth.address':'请先认证出金地址',
    'asset.withdraw.currency':'提取币种',
    'asset.withdraw.amount.balance':'可取金额：',
    'asset.withdraw.amount':'提取数量',
    'asset.withdraw.amount.placeholder':'请输入提取数量',
    'withdraw.all':'全部',
    'asset.withdraw.toAmount': '提取后兑换成',
    'asset.withdraw.percentage':'汇率',
    'asset.withdraw.feeRate':'提取手续费',
    'withdraw.to': '提取至',
    'user.withdraw.change.address': '修改提币地址',
    'asset.withdraw.not.auth':'尚未认证',
    'asset.withdraw.auth.address':'立即认证出金地址',
    'user.forget.trcPsw': '忘记交易密码？',
    'asset.withdraw.tips1': '1、工作日16:00前申请将于18:00-22:00到账，16:00后将于下一个工作日结束前到账，逢节假日与周末顺延。',
    'asset.withdraw.tips2': '2、港美股实行T+2交收制度，卖出股份所得金额T+2交收后可取。',
    'setting.not.bind.mobile': '您未绑定手机，请先绑定手机',
    'setting.not.bind.email': '您未绑定邮箱，请先绑定邮箱',
    'asset.resultTipB': '已通知财务打款，我们将尽快处理。',
    'withdraw.title.new': '提取资金',
    'asset.withdraw.result': '*工作日16:00前申请将于18:00-22:00到账，16:00后将于下一个工作日结束前到账，逢节假日与周末顺延。',

    //换汇
    'asset.outAmount': '兑出金额',
    'asset.maxCan': '最多可兑',
    'asset.finishOutAmount': '请输入兑出金额',
    'asset.allExchange': '全部兑换',
    'asset.afterExchangeBalance': '兑后余额',
    'asset.inAmount': '兑入金额',
    'asset.record.exchange': '立即兑换',
    'exchange.bottom.tip1': '1.页面中展示的汇率仅供参考，请以实际换汇后的金额为准。',
    'exchange.bottom.tip2': '2.当账户中存在未完成结算和交收的资金时，该部分资金不支持换汇。股票一般T日交易，T+2个交易日可完成交收。',

    //换汇记录
    'exchange.record.title': '换汇记录',
    'exchange.record.direction': '兑换方向',
    'exchange.record.table1': '时间',
    'exchange.record.table2': '兑出',
    'exchange.record.table3': '兑入',
    'exchange.record.table4': '汇率',
    'exchange.record.direction1': 'HKD兑USD',
    'exchange.record.direction2': 'HKD兑CNY',
    'exchange.record.direction3': 'USD兑HKD',
    'exchange.record.direction4': 'USD兑CNY',
    'exchange.record.direction5': 'CNY兑HKD',
    'exchange.record.direction6': 'CNY兑USD',

    //资金明细
    'asset.detail.title1.HKD': '证券账户(HKD)',
    'asset.detail.mainItem1': '净资产',
    'asset.detail.mainItem2': '现金',
    'asset.detail.mainItem3': '持仓市值',
    'asset.detail.mainItem4': '人民币现金',
    'asset.detail.mainItem5': '美元现金',
    'asset.detail.mainItem6': '港币现金',
    'asset.detail.mainItem7': '冻结资金',
    'asset.detail.mainItem8': '现金可用',
    'asset.detail.title3': '融资风控',
    'asset.detail.mainItem9': '最大购买力',
    'asset.detail.mainItem10': '融资风险',

    //融资明细
    'asset.financing':'融资明细',
    'asset.financing.totalFinanceBuyPower':'融资最大购买力',
    'asset.financing.debtBalance':'融资欠款',
    'asset.financing.marginValue':'持仓抵押值',
    'asset.financing.marginRatioPlus':'融资风险',
    'asset.financing.marginCall':'追缴保证金',
    'asset.financing.HKCash':'港币余额',
    'asset.financing.USCash':'美元余额',
    'asset.financing.CNYCash':'人民币余额',
    'asset.financing.table1':'持仓',
    'asset.financing.table2':'市值',
    'asset.financing.table3':'抵押率',
    'asset.financing.table4':'抵押值',
    'asset.financing.detail.tip1': '1、融资欠款=多币种融资金额总和，持仓抵押值=持仓股票抵押值总和，融资风险系数=融资欠款/持仓抵押值，追缴保证金=融资欠款-持仓抵押值*85%。',
    'asset.financing.detail.tip2': '2、风险系数70%为警戒线，90%为追缴线，105%为强平线。',
    'asset.financing.detail.tip3': '3、市场行情变化迅速，强平时不一定会及时给您打margin call，请实时关注盘面，注意账户风险，及时补充保证金，或自行先行平仓。',
    'asset.financing.detail.tip4': '4、强平时，可能部分平仓，可能全部平仓，我司保有酌情权。',
    'asset.financing.detail.tip5': '5.新股中签上市后，净资产小于3000HKD的账户，可能导致强平。',
    'asset.financing.detail.tip6': '6、强平会加收100HKD手续费。',

    //出入金流水
    'user.option.success': '操作成功',
    'asset.time': '时间',
    'asset.recharge.record.amount': '入金数量',
    'asset.exchange.amount': '兑换金额',
    'asset.status': '状态',
    'asset.record.status1': '待确认',
    'asset.record.status2': '已完成',
    'asset.record.status3': '未完成',
    'asset.record.status4': '已取消',
    'asset.record.status5': '新建',
    'asset.record.status6': '待扣款',
    'asset.record.status7': '已扣款,待制单',
    'asset.record.status8': '已制单,待打款',
    'asset.record.status9': '用户取消',
    'asset.record.status10': '已驳回',
    'asset.record.currencyCode': '兑换币种',
    'asset.withdraw.record.amount': '出金金额',
    'asset.exchange.withdraw.amount': '兑换数量',
    'asset.currency': '币种',
    'asset.recharge.detail': '入金详情',
    'asset.withdraw.detail': '出金详情',
    'asset.type': '类型',
    'asset.chainType3': 'WICC(维基链)',
    'asset.detail.amount':'数量',
    'asset.hash':'哈希',
    'asset.from.address':'发送地址',
    'asset.to.address':'接收地址',
    'asset.fee': '手续费',
    'asset.reject': '申请驳回',
    'asset.reject.tip1': '出金正在进行中，今日剩余',
    'asset.reject.tip2': '次驳回出金机会，是否确认驳回？',
    'asset.reject.confirm': '确定驳回',

}
